import { grey } from '@mui/material/colors';

export const fulfillmentCountColor = '#EF476F';

export const chartCartesianAxisColor = '#8e8e8e';
export const chartCartesianGridColor = '#dadada';
export const chartReferenceLineColor = '#dadada';
export const chartDataColors = ['#999999', '#38bec9', '#c9388e', '#3858c9'];
export const surveyChartDataColors = [
  '#51B9F3',
  '#50CC9A',
  '#FFBF42',
  '#6789E0',
  '#A467E1',
  '#FF974B',
  '#81DD79',
  '#E393FF',
  '#6664F1',
  '#DF5B63',
];

export const barChartColor = '#47BCE1';
export const darkBarChartColor = '#2C6EB5';

// Yellow intermediary-warning status color for the Retailer Connect Scan Data "getting stale" dot
// (OCST-33438). Distinct from the orange `warning.main` used elsewhere.
export const scanDataWarningColor = '#FFC107';

export const palette = () => ({
  primary: { main: '#6864D1' },
  secondary: {
    main: '#ffffff', // TODO: change it. Secondary color should not be white
  },
  default: {
    main: '#eeeeee',
    light: '#F1F1F1',
    dark: '#A6A6A6',
  },
  success: {
    main: '#4CAF50',
    light: '#DBEFDC',
    dark: '#4CAF50',
  },
  warning: {
    main: '#FF8F00',
    light: '#FFE9CC',
    dark: '#FF8F00',
  },
  info: {
    main: '#4696EC',
    light: '#DAEAFB',
    dark: '#4696EC',
  },
  error: {
    main: '#F44336',
    light: '#FDD9D7',
    dark: '#F44336',
  },
  text: {
    primary: '#212121',
    secondary: '#6B6B6B',
    disabled: '#A6A6A6',
  },
  background: {
    default: grey[200],
  },
  Offers: {
    translucent: 'rgba(104, 100, 209, 0.2)',
  },
  SpinWheel: {
    sectorColors: [
      { color: '#67BDD9', contrastText: '#1E4B7F' },
      { color: '#1E4B7F', contrastText: '#C4E5E3' },
      { color: '#C4E5E3', contrastText: '#1E4B7F' },
    ],
    rimLightColor: '#FFDA56',
    rimNormalColor: '#FEC807',
    rimDarkColor: '#E89800',
    rimShadowColor: 'rgba(0, 0, 0, 0.2)',
    risingSunBackColor: '#30386d',
    risingSunRaysColor: '#3f4776',
    risingSunTextColor: '#ffffff',
  },

  WalletSteeringOpportunityIndicatorColors: [
    '#6ECC9E',
    '#8060FF',
    '#FFC300',
    '#FF6B6B',
    '#1982C4',
    '#FF9D56',
  ],
  barChart: {
    bar: barChartColor,
    selectedBar: barChartColor,
    notSelectedBar: '#daf2f9',
  },
  SurveyMetricsChart: {
    surveyViewBarColor: '#149DD6',
    responseRateLineColor: '#FF4CAD',
  },
  ReferralProgramMetricsChart: {
    uniqueCodesSharedColor: '#FF4CAD',
    newMembersReferredColor: '#149DD6',
  },
  drive: {
    textPrimary: '#384182',
    textSecondary: '#7178A7',
    border: '#e2e6ff',
    background: '#F6F7FE',
    backgroundLight: '#F4F6FF',
    chipBg: 'rgba(50, 47, 131, 0.06)',
    chipHover: '#dcdcff',
  },
});
